<template>
  <StructuredData id="schema-webpage" :schema="webPageSchema" />
  <div v-if="!initializing" class="container superior">
    <div class="row">
      <div class="col">
        <h2 class="text-primary display-5 fw-bold text-start">{{ $t('general.politicaCookies') }}</h2>
      </div>
    </div>
    <div class="row mt-4">
      <div class="card card-body">
        <p v-sanitize-html="politicaCookies" class="politica"></p>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onBeforeMount } from 'vue';
  import HomeApiService from '@/services/api/skiandnight/HomeApiService';
  import StructuredData from '@/components/utils/StructuredData.vue';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import { usePageMeta } from '@/composables/usePageMeta';

  const loadingStore = useLoadingStore();
  const { webPageSchema } = usePageMeta();
  const initializing = ref(true);
  const politicaCookies = ref('');

  async function fetchPoliticaCookies() {
    try {
      loadingStore.show();
      const response = await HomeApiService.getCookiePolicy();
      politicaCookies.value = response.texto;
    } catch (error) {
      console.error('Error al obtener la política de cookies:', error);
      politicaCookies.value = '';
    } finally {
      initializing.value = false;
      loadingStore.hide();
    }
  }

  onBeforeMount(() => {
    fetchPoliticaCookies();
  });
</script>

<style scoped lang="scss">
  .card-body {
    border: none;
    padding: 2rem;

    .politica {
      margin-bottom: 1rem;
    }
  }

  .superior {
    max-width: 1200px;
    margin: 0 auto;
    padding: 25px 0;
    padding-top: 11rem;
  }

  @media only screen and (max-width: 768px) {
    .superior {
      padding: 7rem 15px;
    }

    .card-body {
      padding: 1rem;
    }
  }
</style>
